<template>
    <div
        class="burger-button"
        :class="{'is-active': isOpen}"
        @click="onBurgerClick"
    >
        <span />
    </div>
</template>
<script>
export default {
    name: 'BurgerButton',
    emits: ['onClick'],
    data() {
        return {
            isOpen: false,
        }
    },
    methods: {
        onBurgerClick() {
            this.isOpen = !this.isOpen
            this.$emit('onClick')
        }
    }
}
</script>
<style scoped>
.burger-button {
    position: relative;
    width: 22px;
    height: 22px;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
}
.burger-button span {
    position: absolute;
    width: 100%;
    height: 3px;
    background-color: var(--primary-blue);
    border-radius: 4px;
    transition: .2s ease-in-out;
}
.burger-button:before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 3px;
    background-color: var(--primary-blue);
    border-radius: 4px;
    transition: .2s ease-in-out;
}
.burger-button:after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 3px;
    background-color: var(--primary-blue);
    border-radius: 4px;
    transition: .2s ease-in-out;
}
.burger-button.is-active span {
    width: 0;
}
.burger-button.is-active:before {
    top: 50%;
    transform: translateY(-50%) rotate(45deg);
    background-color: var(--additional-dark-blue);
}
.burger-button.is-active:after {
    bottom: 50%;
    transform: translateY(50%) rotate(-45deg);
    background-color: var(--additional-dark-blue);
}
</style>
